import { parse as resourceSpecifierFromString } from '@gonfalon/resource-specifiers/parser';

import type { ApprovalRequestResourceKind } from './types';

/**
 * Derives the kind of resource an approval request acts upon from its resource specifier.
 *
 * The `resourceId` property is only supplied when the approval request is fetched via the
 * /approval-requests API endpoints. The flag config approval request endpoint does not supply it,
 * so a missing `resourceId` means the request acts upon a flag configuration.
 */
export function getApprovalRequestResourceKind(resourceId?: string): ApprovalRequestResourceKind {
  if (!resourceId) {
    return 'FlagConfiguration';
  }

  const result = resourceSpecifierFromString(resourceId);

  if (result.err) {
    throw new Error(result.val.message);
  }

  switch (result.val.type) {
    case 'flag':
      return result.val.environment.name === '*' ? 'Flag' : 'FlagConfiguration';
    case 'segment':
      return 'Segment';
    case 'aiconfig':
      return 'AiConfig';
    case 'experiment':
      return 'Experiment';
    default:
      return 'FlagConfiguration';
  }
}
